import { render, staticRenderFns } from "./avatarGroup.vue?vue&type=template&id=8e0f5238&scoped=true&"
var script = {}
import style0 from "./avatarGroup.vue?vue&type=style&index=0&id=8e0f5238&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0f5238",
  null
  
)

export default component.exports